import api from './api';

/** Processing `UserTermsOfServiceAcceptanceResponse.v1` — POST `/public/processing/v1/user/terms`. */
interface AcceptTermsOfServiceResponse {
  success: boolean;
}

/**
 * Yii TermsAndConditionsController::actionAccept — `asJson(['success'])` → JSON `["success"]`.
 */
type TermsAndConditionsAcceptResponse = readonly ['success'];

export const acceptTermsOfService = () => {
  const rootUrl = PROCESSING_API_URL; // eslint-disable-line no-undef

  return api.post<AcceptTermsOfServiceResponse>(`${rootUrl}/public/processing/v1/user/terms`, {
    isTosAccepted: true,
  });
};

export const clearUserCache = () => {
  // XXX: we need to clean user information from cache, so we get new user details from api
  return api.post<TermsAndConditionsAcceptResponse>('/legacy-api/terms-and-conditions/accept/');
};
